import { Button, Form, Modal, Radio } from 'antd';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { CAMPAIGN_GROUP_TYPE, groupCampaignOptions } from './customerFilterConstant';
import Box from '../../../../../components/Box';
import FilterOptions from './FilterOptions';
import styled from 'styled-components';

type Props = {
  formFilter: any;
};

export type FilterModalRef = {
  open: (data: string[]) => void;
  close: () => void;
};

const FilterModal = forwardRef<FilterModalRef, Props>(({ formFilter }, ref) => {
  const [form] = Form.useForm();
  const [showModal, setShowModal] = useState(false);

  const getGroupType = (filterValue: string) => {
    if (!filterValue) return CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN;
    const groupType = Object.values(CAMPAIGN_GROUP_TYPE).find((type) =>
      filterValue.startsWith(`${type}_`)
    );
    return groupType;
  };
  const onOpen = (data: string[]) => {
    setShowModal(true);
    if (!data?.length) {
      const fields = { filterRadioGroup: getGroupType(data?.[0]) };
      form.setFieldsValue(fields);
      return;
    } else {
      const fields = {
        filterRadioGroup: getGroupType(data?.[0]),
        notVisitedTimePeriod: data?.[0],
        visitedWithinTimePeriod: data?.[0],
        reviewStars: data,
        visitCount: data,
        avgSpend: data,
        rewardStatus: data,
        birthdayMonth: data,
      };
      form.setFieldsValue(fields);
    }
  };

  useImperativeHandle(ref, () => ({
    open: (data: string[]) => {
      onOpen(data);
    },
    close: () => {
      setShowModal(false);
    },
  }));

  const convertFilterRadioGroupToCampaignName = (filterName: string) => {
    switch (filterName) {
      case CAMPAIGN_GROUP_TYPE.HAVE_NOT_VISITED_IN:
        return 'notVisitedTimePeriod';
      case CAMPAIGN_GROUP_TYPE.VISITED_WITHIN:
        return 'visitedWithinTimePeriod';
      case CAMPAIGN_GROUP_TYPE.REVIEW_GROUP:
        return 'reviewStars';
      case CAMPAIGN_GROUP_TYPE.NUMBER_OF_VISIT:
        return 'visitCount';
      case CAMPAIGN_GROUP_TYPE.AVG_VISIT:
        return 'avgSpend';
      case CAMPAIGN_GROUP_TYPE.REWARD_GROUP:
        return 'rewardStatus';
      case CAMPAIGN_GROUP_TYPE.BIRTHDAY_MONTH:
        return 'birthdayMonth';
      default:
        return '';
    }
  };
  const onSelectedFilterOptions = (values: any) => {
    const { filterRadioGroup, ...filterValues } = values;
    const filterName = convertFilterRadioGroupToCampaignName(filterRadioGroup);
    const filterValue = filterValues[filterName];
    const newData = Array.isArray(filterValue) ? filterValue : [filterValue];
    formFilter?.setFieldsValue({ filterCustomerGroup: newData });
    setShowModal(false);
  };

  const onCancel = () => {
    setShowModal(false);
    form.resetFields();
  };

  return (
    <Modal
      title='Filter Customers'
      open={showModal}
      onCancel={onCancel}
      width={900}
      footer={null}
      destroyOnClose
      centered
    >
      <Form layout='vertical' form={form} onFinish={onSelectedFilterOptions}>
        <Form.Item name='filterRadioGroup'>
          <RadioGroup>
            <GridBox>
              {groupCampaignOptions.map((option) => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </GridBox>
          </RadioGroup>
        </Form.Item>

        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const filterType = getFieldValue('filterRadioGroup');
            const filterName = convertFilterRadioGroupToCampaignName(filterType);
            return <FilterOptions type={filterType} name={filterName} />;
          }}
        </Form.Item>

        <Box display='flex' justifyContent='space-between' gap={2} mt={4}>
          <Box width='100%'>
            <Button onClick={onCancel} block>
              Close
            </Button>
          </Box>
          <Box width='100%'>
            <Button type='primary' htmlType='submit' block>
              Done
            </Button>
          </Box>
        </Box>
      </Form>
    </Modal>
  );
});

FilterModal.displayName = 'FilterModal';

export default FilterModal;

const GridBox = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`;

const RadioGroup = styled(Radio.Group)`
  .ant-radio-wrapper {
    width: 100%;
  }
`;
